import React from "react";
import { useIntl, FormattedMessage } from "react-intl";

import { useStyles } from "./style";
import { PageTitle } from "../../components/page-title/PageTitle";
import { Box, Typography } from "@material-ui/core";
import { APP_NAME } from "../../settings/constants";
import CustomLink from "./components/CustomLink";

interface InternalErrorPageProp {}

const InternalErrorPage = (props: InternalErrorPageProp) => {
  const classes = useStyles();
  const intl = useIntl();

  return (
    <>
      <PageTitle
        title={intl.formatMessage({
          id: "sharedScreen.forbidden",
        })}
      />
      <Box className={classes.root}>
        <Box className={classes.wrapper}>
          <Box mb={4}>
            <Typography component="h4" variant="h4" className={classes.appNameTitle}>
              {APP_NAME}
            </Typography>
          </Box>
          <Typography component="h2" variant="h2" className={classes.title}>
            500
          </Typography>
          <Typography component="h4" variant="h4" className={classes.subTitle}>
            <FormattedMessage id="sharedScreen.internalError" />
          </Typography>
          <Box mt={1} style={{ textAlign: "center" }}>
            <Typography component="p" className={classes.description}>
              <FormattedMessage id="error.error" />
            </Typography>
          </Box>
          <Box
            mt={4}
            style={{ textAlign: "center" }}
            className={classes.customLink}
          >
            <CustomLink />
          </Box>
        </Box>
      </Box>
    </>
  );
};

InternalErrorPage.routeName = "/error/500";

export default InternalErrorPage;
